<template>
  <div>
    <!-- https://youzan.github.io/vant/#/zh-CN/image#api @load="handleLoad"-->
    <van-image v-bind="$attrs" style="display:block;">
      <template v-slot:loading>
        <div class="loading_bg" :style="'background:url(/imageConfig/'+$store.getters.platform+'加载中.webp);background-size: 100% 100%;'">
          <!-- <van-loading type="spinner" size="20" /> -->
        </div>
      </template>
      <!-- <template v-slot:default>
        <div class="loading_bg" />
      </template> -->
      <!-- <template v-slot:error>加载失败</template> -->
    </van-image>
  </div>
</template>
<script>
export default {
  name: 'ImagePic',
  data() {
    return {
    }
  },
  methods: {
    // handleLoad(e) {
    //   console.log('图片加载完成', e)
    // }
  }
}
</script>
<style lang="less" scoped>
.loading_bg{
  // background: url(~@/assets/portal/home/加载中.webp);
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
}
</style>
<style lang="less">
.van-image__img{
  border-radius: 6px;
}
.van-image__img, .van-image__error, .van-image__loading {
  border-radius: 6px;
}
</style>